import type { ProjectDataset } from './types';

export const initialProjectDatasetState: ProjectDataset = {
  projectName: null,
  siteName: null,
  iterationName: null,
};
